"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "castel-san-giorgio": {
    "a4375aea": [{
      "hkey": "fe8890f0",
      "slug": "castel-san-giorgio",
      "name": "Castel San Giorgio",
      "primary": true,
      "skipSearch": false
    }],
    "aiello": [{
      "hkey": "fe8890f0",
      "slug": "castel-san-giorgio",
      "name": "Castel San Giorgio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a288f064": [{
      "hkey": "fe8890f0",
      "slug": "castel-san-giorgio",
      "name": "Castel San Giorgio",
      "primary": true,
      "skipSearch": false
    }],
    "campomanfoli": [{
      "hkey": "fe8890f0",
      "slug": "castel-san-giorgio",
      "name": "Castel San Giorgio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e490a58a": [{
      "hkey": "fe8890f0",
      "slug": "castel-san-giorgio",
      "name": "Castel San Giorgio",
      "primary": true,
      "skipSearch": false
    }],
    "castelluccio": [{
      "hkey": "fe8890f0",
      "slug": "castel-san-giorgio",
      "name": "Castel San Giorgio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "40b776d6": [{
      "hkey": "fe8890f0",
      "slug": "castel-san-giorgio",
      "name": "Castel San Giorgio",
      "primary": true,
      "skipSearch": false
    }],
    "cortedomini": [{
      "hkey": "fe8890f0",
      "slug": "castel-san-giorgio",
      "name": "Castel San Giorgio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "67f1cda4": [{
      "hkey": "fe8890f0",
      "slug": "castel-san-giorgio",
      "name": "Castel San Giorgio",
      "primary": true,
      "skipSearch": false
    }],
    "fimiani": [{
      "hkey": "fe8890f0",
      "slug": "castel-san-giorgio",
      "name": "Castel San Giorgio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b9814863": [{
      "hkey": "fe8890f0",
      "slug": "castel-san-giorgio",
      "name": "Castel San Giorgio",
      "primary": true,
      "skipSearch": false
    }],
    "santa-croce": [{
      "hkey": "fe8890f0",
      "slug": "castel-san-giorgio",
      "name": "Castel San Giorgio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3e5621b2": [{
      "hkey": "fe8890f0",
      "slug": "castel-san-giorgio",
      "name": "Castel San Giorgio",
      "primary": true,
      "skipSearch": false
    }],
    "santa-maria-a-favore": [{
      "hkey": "fe8890f0",
      "slug": "castel-san-giorgio",
      "name": "Castel San Giorgio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9cdd4a94": [{
      "hkey": "fe8890f0",
      "slug": "castel-san-giorgio",
      "name": "Castel San Giorgio",
      "primary": true,
      "skipSearch": false
    }],
    "torello": [{
      "hkey": "fe8890f0",
      "slug": "castel-san-giorgio",
      "name": "Castel San Giorgio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e1964875": [{
      "hkey": "fe8890f0",
      "slug": "castel-san-giorgio",
      "name": "Castel San Giorgio",
      "primary": true,
      "skipSearch": false
    }],
    "trivio": [{
      "hkey": "fe8890f0",
      "slug": "castel-san-giorgio",
      "name": "Castel San Giorgio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;